import { EventSnapshotItem } from "./EventSnapshotItem";

export default EventSnapshotItem;
